/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';
/**
 * An edit icon.
 * Used for editing tasting notes for example.
 *
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function CatalogIcon({ className, size = 'xsmall' }) {
    return (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", 
        // @ts-ignore
        sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        }, className: className, viewBox: "0 0 20 20" },
        jsx("defs", null,
            jsx("path", { id: "path-1", d: "M3 1v14h11.001C14 15 14 10.333 14 1H3zm14 0v15.493c0 .833-.67 1.507-1.502 1.507H4v-1h11.498a.502.502 0 00.502-.507V1h1zm-2.999-1c.552 0 .999.447.999.996v13.996c0 .557-.447 1.008-.999 1.008H2V0h12.001zM1 4a.5.5 0 010-1h3a.5.5 0 010 1H1zm0 9a.5.5 0 110-1h3a.5.5 0 110 1H1z" })),
        jsx("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
            jsx("g", { transform: "translate(1 1)" },
                jsx("mask", { id: "mask-2", fill: "#fff" },
                    jsx("use", { xlinkHref: "#path-1" })),
                jsx("use", { fill: "currentColor", fillRule: "nonzero", xlinkHref: "#path-1" }),
                jsx("g", { fill: "none", mask: "url(#mask-2)" },
                    jsx("path", { d: "M0 0H40V41H0z", transform: "translate(-11 -11)" }))))));
}
//# sourceMappingURL=CatalogIcon.js.map